export default "__VITE_ASSET__1e46094d__"